import {
  Col,
  Row,
  Form,
  Breadcrumb,
  Tabs,
  Select,
  DatePicker,
  message,
  Input,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { Link } from "react-router-dom";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { InputNumber } from "../UI/InputNumberComponent/inputnumber";
import TextArea from "../UI/InputNumberComponent/TextArea";
import dayjs from "dayjs";
import { useMutation } from "react-query";
import { PaymentType } from "./receiptsType";
import {
  createPayments,
  editPayments,
  getCustomerDropdownFiltered,
  getSalesDropdown,
  getSalesNullDropdown,
} from "../../api/receipts";

function AddEditCustomerBalance() {
  const [t] = useTranslation("common");
  const [key, setKey] = useState("1");
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const isEdit = () => {
    return !!id;
  };
  const onChange = (key: string) => {
    setKey(key);
  };
  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
    },
  ];

  const location = useLocation();
  const Payment = location?.state?.Payment;
  const formatedCurrency = location?.state?.formatedCurrency;
  const loadingCurrency = location?.state?.loadingCurrency;
  const formatedPaymentMode = location?.state?.formatedPaymentMode;
  const loadingPaymentMode = location?.state?.loadingPaymentMode;

  const [selectedCustomer, setSelectedCustomer] = useState<null>(null);
  const [selectedCurrency, setSelectedCurrency] = useState<any>(null);
  const [Currency, setCurrency] = useState<any>(null);
  const [selectedSales, setSelectedSales] = useState<any>(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState<any>(null);
  const [date, setDate] = useState<any>(null);
  const [dueDate, setDueDate] = useState<any>(null);

  const handleDateChange = (value: any) => {
    setDate(value);
  };

  const handleDueDateChange = (value: any) => {
    setDueDate(value);
  };

  const [formatedCustomers, setFormatedCustomers] = useState<{}[]>();
  const { isLoading: loadingCustomers, mutate: CustomerMutation } = useMutation(
    "customers",
    () => getCustomerDropdownFiltered(true),
    {
      onSuccess: (res) => {
        setFormatedCustomers(
          res.data
            .filter((customer: any) =>
              isEdit() ? customer : customer.isActive
            )
            .map((customer: any) => {
              return { value: customer.id, label: customer.name };
            })
        );
      },
    }
  );

  const [formatedsales, setFormatedSales] = useState<any>([]);
  const { mutate: mutationSales, isLoading: isSalesLoading } = useMutation(
    "getSales",
    (customerId: number) => getSalesDropdown(customerId),
    {
      onSuccess: (result) => {
        setFormatedSales(
          result?.data
            .filter((sale: any) => sale.isPaid === false)
            .map((sale: any) => {
              return {
                value: sale.id,
                label: sale.invoiceNo + " - " + sale.remainingAmountText,
              };
            })
        );
      },
    }
  );
  const [formatedsale, setFormatedSale] = useState<any>([]);
  const { isLoading: loadingSale, mutate: SaleMutation } = useMutation(
    "getSales",
    getSalesNullDropdown,
    {
      onSuccess: (res) => {
        setFormatedSale(
          res.data
            .filter((sale: any) => sale.isPaid === false)
            .map((sale: any) => {
              return {
                value: sale.id,
                label: sale.invoiceNo + " - " + sale.remainingAmountText,
                remainingAmount: sale.remainingAmount,
              };
            })
        );
      },
    }
  );

  const [selectedSale, setSelectedSale] = useState(null);

  const handleSaleSelect = (value: any) => {
    setSelectedSale(value);

    // Find the selected sale by its ID and get the remainingAmount
    const selectedSaleData = formatedsale.find(
      (sale: any) => sale.value === value
    );

    // Update the "amount" field in the form with the remainingAmount
    form.setFieldValue(
      "amount",
      selectedSaleData ? selectedSaleData.remainingAmount.toFixed(2) : null
    );
  };

  const [editStatus] = useState(isEdit());

  useEffect(() => {
    if (editStatus) {
      setSelectedCurrency(true);
      setSelectedSales(true);
      setSelectedPaymentMode(true);
      setDueDate(true);
      setDate(true);
    }
  }, [editStatus]);

  const [, setError] = useState("");

  const onError = (error: any, variables: PaymentType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const sessionId = useRef(localStorage.getItem("sessionId"));
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createPayments" : "editPayments",
    !isEdit()
      ? (payment: PaymentType) =>
          createPayments({ ...payment, sessionId: sessionId.current })
      : (payment: PaymentType) =>
          editPayments(id, { ...payment, sessionId: sessionId.current }),
    {
      onSuccess: (res) => {
        navigate("/customerreceipts");
        message.success("Complete successfully");
      },
      onError,
    }
  );
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;
  const handleCurrencySelection = (value: any) => {
    setCurrency(value);
    if (value === mainCurrency?.id) {
    }
    setSelectedCurrency(value);
  };

  useEffect(() => {
    if (isEdit()) {
      form.setFieldsValue({
        customerId: Payment?.pSale?.customer?.id,
        saleId: Payment?.pSale?.invoiceNo,
        currencyId: Payment?.curr?.id,
        paymentModeId: Payment?.paymentMode?.id,
        notes: Payment?.notes,
        exchangeRate: Payment?.exchangeRate,
        amount: Payment?.amount,
        reference: Payment?.reference,
        date: dayjs(new Date(Payment?.date)),
        dueDate: dayjs(new Date(Payment?.dueDate)),
      });
      if (mainCurrency?.id === Payment?.curr?.id) {
        setCurrency(Payment?.curr?.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleFinish = () => {
    const newPayments = form.getFieldsValue();
    const selectedSaleNumber = newPayments.saleId;
    const correspondingSale = formatedsales.find(
      (sale: any) => sale.label === selectedSaleNumber
    );
    if (correspondingSale) {
      newPayments.saleId = correspondingSale.value;
    }
    for (const key in newPayments) {
      if (newPayments[key] === undefined) {
        newPayments[key] = null;
      } else if (
        typeof newPayments[key] === "string" &&
        newPayments[key].trim() === ""
      ) {
        newPayments[key] = null;
      }
      if (Currency === mainCurrency?.id) {
        newPayments.exchangeRate = 1;
      }
    }

    const selectedDate = form.getFieldValue("date");
    let selectedDateTime = dayjs(Payment?.date).format("HH:mm:ss");
    const dateTime = !selectedDate.isSame(dayjs(Payment?.date), "day");
    if (dateTime) {
      selectedDateTime = dayjs().format("HH:mm:ss");
    }
    newPayments.date =
      dayjs(selectedDate).format("MM/DD/YYYY") + " " + selectedDateTime;

    const selectedDueDate = form.getFieldValue("dueDate");
    let selecteddueDateTime = dayjs(Payment?.dueDate).format("HH:mm:ss");
    const dueDate = !selectedDueDate.isSame(dayjs(Payment?.dueDate), "day");
    if (dueDate) {
      selecteddueDateTime = dayjs().format("HH:mm:ss");
    }
    newPayments.dueDate =
      dayjs(selectedDueDate).format("MM/DD/YYYY") + " " + selecteddueDateTime;
    newPayments.isPosted = false;
    newPayments.postedDate = null;
    mutateCreateUpdate(newPayments);
  };
  useEffect(() => {
    SaleMutation();
    CustomerMutation();
    isEdit() && mutationSales(Payment?.pSale?.customer?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateDueDate = (_: any, value: any) => {
    const selectedDate = form.getFieldValue("date");
    if (value && selectedDate && value.isBefore(selectedDate, "day")) {
      return Promise.reject("Due date cannot be before the selected date.");
    }
    return Promise.resolve();
  };

  return (
    <>
      <Row>
        <Col offset={1} span={22}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("sales")}</>,
              },
              {
                title: <Link to="/customerreceipts">{t("receipts-list")}</Link>,
              },
              {
                title: (
                  <>
                    {" "}
                    {isEdit()
                      ? `${t("edit-receipts")}`
                      : `${t("add-receipts")}`}
                  </>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("general-information")}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() ? (
          <Col className="editTitle" offset={1} span={20}>
            {Payment?.pSale?.customer?.name}
          </Col>
        ) : (
          <Col className="editTitle" offset={1} span={20}>
            {t("add-receipts-form")}
          </Col>
        )}
      </Row>
      <Col offset={1} span={22}>
        <Tabs
          data-testid="tab"
          className="ant-tab"
          defaultActiveKey="1"
          activeKey={key}
          items={items}
          onChange={onChange}
        />
      </Col>
      <Col offset={1}>
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          id="paymentForm"
        >
          <Row style={{ minHeight: "55vh" }}>
            <Col span={6}>
              <Form.Item name="customerId" label={t("customer")}>
                <Select
                  placeholder={t("select-customer")}
                  showSearch={true}
                  optionFilterProp="label"
                  onChange={(value: any) => {
                    setSelectedCustomer(value);
                    mutationSales(value);
                  }}
                  options={formatedCustomers}
                  loading={loadingCustomers}
                />
              </Form.Item>

              <Form.Item
                name="saleId"
                label={t("sales")}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {selectedCustomer ? (
                  <Select
                    placeholder={t("select-sales")}
                    data-testid="saleId"
                    showSearch={true}
                    loading={isSalesLoading}
                    options={formatedsales}
                    optionFilterProp="label"
                    onChange={(value: any) => setSelectedSales(value)}
                  />
                ) : (
                  <Select
                    placeholder={t("select-sales")}
                    data-testid="saleId"
                    showSearch={true}
                    loading={loadingSale}
                    options={formatedsale}
                    optionFilterProp="label"
                    onChange={handleSaleSelect}
                    value={selectedSale}
                  />
                )}
              </Form.Item>

              <Form.Item
                name="paymentModeId"
                label={t("payment-mode")}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t("select-payment-mode")}
                  data-testid="pay-method"
                  options={formatedPaymentMode}
                  loading={loadingPaymentMode}
                  showSearch={true}
                  optionFilterProp="label"
                  onChange={(value: any) => setSelectedPaymentMode(value)}
                />
              </Form.Item>

              <Form.Item name="reference" label={t("reference-number")}>
                <Input
                  maxLength={50}
                  data-testid="reference"
                  placeholder={`${t("enter-text")}`}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col offset={2} span={6}>
              <Form.Item
                name="date"
                label="Date"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  data-testid="date"
                  style={{ width: "100%" }}
                  placeholder={`${t("MM/DD/YYYY")}`}
                  onChange={handleDateChange}
                />
              </Form.Item>

              <Form.Item
                name="currencyId"
                label={t("currency")}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t("select-currency")}
                  data-testid="currency"
                  showSearch={true}
                  optionFilterProp="label"
                  options={formatedCurrency}
                  loading={loadingCurrency}
                  onChange={handleCurrencySelection}
                />
              </Form.Item>

              <Form.Item name="exchangeRate" label={t("exchange-rate")}>
                <Input
                  maxLength={10}
                  data-testid="exchange"
                  disabled={Currency === mainCurrency?.id}
                  autoComplete="off"
                  placeholder={`${t("enter-text")}`}
                />
              </Form.Item>

              <Form.Item
                name="amount"
                label={t("amount")}
                rules={[
                  {
                    required: true,
                    message: "amount is required",
                  },
                ]}
              >
                <InputNumber maxLength={25} data-testid="amount" />
              </Form.Item>
            </Col>

            <Col offset={1} span={6}>
              <Form.Item
                name="dueDate"
                label={t("due-date")}
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: validateDueDate,
                  },
                ]}
              >
                <DatePicker
                  data-testid="due-date"
                  style={{ width: "100%" }}
                  placeholder={`${t("MM/DD/YYYY")}`}
                  onChange={handleDueDateChange}
                  value={dueDate}
                />
              </Form.Item>

              <Form.Item name="notes" label={`${t("notes")}`}>
                <TextArea
                  autoComplete="off"
                  data-testid="description"
                  maxLength={500}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>

      <Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <AddEditButton
              disabled={
                !date || !dueDate || !selectedCurrency || !selectedPaymentMode
              }
              onClick={() => {
                setOpen(true);
              }}
              data-testid="add-button"
              isLoading={undefined}
            />
          </Col>
        </Col>
      </Row>

      <AddEditModal
        form="paymentForm"
        open={open}
        setOpen={setOpen}
        name={<span> {Payment?.pSale?.customer?.name}</span>}
        title={`${t("payment")}`}
        isSaving={isSaving}
      />
    </>
  );
}

export default AddEditCustomerBalance;
